import { createContext, useContext, useEffect, useSyncExternalStore } from "react";
import type { ReactNode } from "react";
import type { SessionManager, SessionState } from "./manager";

const Ctx = createContext<SessionManager | null>(null);

/** 세션 관리자를 React 에 연결하고, 탭이 다시 보이면 갱신 시각을 확인한다. */
export function SessionProvider({
  manager,
  children,
}: {
  manager: SessionManager;
  children: ReactNode;
}) {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") void manager.wake();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
    };
  }, [manager]);
  return <Ctx.Provider value={manager}>{children}</Ctx.Provider>;
}

export function useSessionManager(): SessionManager {
  const m = useContext(Ctx);
  if (!m) throw new Error("SessionProvider 밖에서 세션을 찾았습니다");
  return m;
}

export function useSession(): SessionState {
  const m = useSessionManager();
  return useSyncExternalStore(m.subscribe, m.getState, m.getState);
}
